// 收藏接口
import axios from '@/utils/edu_request'
// 请求课程列表接口
export function getCollectLesson(params) {
  return axios({
    url: '/lesson/lesson/collectLesson',
    dataType: 'json',
    method: 'GET',
    params

  })
}
